import React from 'react';

import { IPostCard, PostCard } from '../Card';

import style from './PostGrid.scss';

import cn from 'classnames';

interface IProps {
  posts: {
    node: IPostCard;
  }[];
  isExcerptShown?: boolean;
}

export const PostGrid = ({ posts, isExcerptShown }: IProps) => (
  <div className={cn('container', style.default)}>
    <div className="row">
      {posts.map(({ node }, index) => (
        <div key={index} className={cn('col-12 col-md-6 col-lg-4', style.post)}>
          <PostCard post={node} isExcerptShown={isExcerptShown} />
        </div>
      ))}
    </div>
  </div>
);
